var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-menu-container",
      style: [_vm.xPosition, _vm.yPosition],
      attrs: { "data-app": "" }
    },
    [
      _c(
        "v-list",
        { staticClass: "pa-0", attrs: { subheader: "" } },
        _vm._l(_vm.menuItems, function(item) {
          return item.visible
            ? _c(
                "v-list-item",
                {
                  key: item.title,
                  staticClass: "px-1",
                  staticStyle: { height: "24px", "min-height": "24px" },
                  on: {
                    click: function($event) {
                      return _vm.executeAction(item.id)
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "mr-2", attrs: { size: "17" } }, [
                    _vm._v(_vm._s(item.icon))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pr-2 object-menu-title" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ],
                1
              )
            : _vm._e()
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-132bb378", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132bb378","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/LeftSidebar/HierarchyObjectMenu.vue
// module id = null
// module chunks = 